module.exports = {
  // TODO: change your profile information here
  name: "Soumava Banerjee",
  greeting: "Hey there 👋",
  greetingDescription: "I'm Soumava Banerjee and I'm a Software Developer!",
  githubUrl: "https://github.com/SoumavaBanerjee",
  linkedinUrl: "https://www.linkedin.com/in/soumavabanerjee--/",
  cvLink:
    "https://drive.google.com/file/d/1eOKLTGB_NwCtPL9r10vc6_6ckWP8VxE2/view?usp=drivesdk",
};
